<template>
  <div>
    <Head :title="`${type.name} Category`" />
    <h1 class="mb-8 text-3xl font-bold"> 
      <Link class="text-orange-400 hover:text-orange-600" href="/sku-types">{{ type.name }} Sku Type</Link>
      Categories
    </h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <Link class="btn-orange" :href="`/sku-type/${type.id}/categories/create`">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;</span> Categories
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3 border-t">Description</th>
          <th class="pb-3 pt-3 px-3 border-t">Code</th>
          <th class="pb-3 pt-3 px-3 border-t">Contained In</th>
          <th class="pb-3 pt-3 px-3 border-t">
            <icon name="settings-white" class="block w-6 h-6 fill-gray-400" />
          </th>
        </tr>
        <tr v-for="(category, index) in categories.data" :key="index" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/sku-type/${type.id}/categories/${category.id}/edit`">
              {{ category.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" href="#" tabindex="-1">
              {{ category.code }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3" href="#" tabindex="-1">
              {{ category.parent }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-3" href="#" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="categories.data.length === 0">
          <td class="px-3 py-3 border-t" colpan="4">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="categories.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    type: Object,
    categories: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/sku-type/${this.type.id}/categories`, pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
